import * as yup from 'yup';

export const validationSchema = yup.object().shape({
    LastName: yup.string().required('Обязательное поле'),
    FirstName: yup.string().required('Обязательное поле'),
    MiddleName: yup.string().required('Обязательное поле'),
    BirthDate: yup
        .string()
        .required('Обязательное поле')
        .matches(
            /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[012])\.(19[0-9][0-9]|20[0-2][0-9])$/,
            'Неверная дата'
        )
        .test(
            'is-valid-date',
            'Некорректная дата',
            (value) => {
                const [day, month, year] = value.split('.').map(Number);
                const date = new Date(year, month - 1, day);
                const minDate = new Date(1915, 0, 1);
                return (
                    date.getFullYear() === year &&
                    date.getMonth() === month - 1 &&
                    date.getDate() === day &&
                    date >= minDate
                );
            }
        ),
});

export const validationSchemaInsurance = yup.object().shape({
    Fio: yup.string().required('Обязательное поле'),
    LastName: yup.string().required('Обязательное поле'),
    FirstName: yup.string().required('Обязательное поле'),
    MiddleName: yup.string().required('Обязательное поле'),
    BirthDate: yup
        .string()
        .required('Обязательное поле')
        .matches(
            /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[012])\.(19[0-9][0-9]|20[0-2][0-9])$/,
            'Неверная дата'
        )
        .test(
            'is-valid-date',
            'Некорректная дата',
            (value) => {
                const [day, month, year] = value.split('.').map(Number);
                const date = new Date(year, month - 1, day);
                const minDate = new Date(1915, 0, 1);
                return (
                    date.getFullYear() === year &&
                    date.getMonth() === month - 1 &&
                    date.getDate() === day &&
                    date >= minDate
                );
            }
        ),
    Gender: yup.string().required('Обязательное поле'),
    Email: yup
        .string()
        .required('Обязательное поле')
        .email('Некорректный формат почты'),
    Phone: yup
        .string()
        .required('Обязательное поле')
});
export const insuredValidationSchema = yup.object().shape({
    InsuredList: yup.array().of(
        yup.object().shape({
            Fio: yup.string().required('Обязательное поле'),
            LastName: yup.string().required('Необходимо указать ФИО полностью'),
            FirstName: yup.string().required('Необходимо указать ФИО полностью'),
            MiddleName: yup.string().required('Необходимо указать ФИО полностью'),
            BirthDate: yup
                .string()
                .required('Обязательное поле')
                .matches(
                    /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[012])\.(19[0-9][0-9]|20[0-2][0-9])$/,
                    'Неверная дата'
                )
                .test(
                    'is-valid-date',
                    'Некорректная дата',
                    (value) => {
                        const [day, month, year] = value.split('.').map(Number);
                        const date = new Date(year, month - 1, day);
                        const minDate = new Date(1915, 0, 1);
                        return (
                            date.getFullYear() === year &&
                            date.getMonth() === month - 1 &&
                            date.getDate() === day &&
                            date >= minDate
                        );
                    }
                ),
            Gender: yup.string().required('Обязательное поле'),
        })
    ),
});

export const getValidationSchema = (requireClientId: boolean) => {
    let schema = yup.object().shape({
        Fio: yup
            .string()
            .required('Обязательное поле')
            .matches(
                /^[а-яА-ЯёЁ\s-]+$/,
                'Поле может содержать только русские буквы, пробелы и тире'
            ),
        LastName: yup.string().required('Необходимо указать ФИО полностью'),
        FirstName: yup.string().required('Необходимо указать ФИО полностью'),
        MiddleName: yup.string().required('Необходимо указать ФИО полностью'),
        BirthDate: yup
            .string()
            .required('Обязательное поле')
            .matches(
                /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[012])\.(19[0-9][0-9]|20[0-2][0-9])$/,
                'Неверная дата'
            )
            .test(
                'is-valid-date',
                'Страхователь должен быть не моложе 18 лет',
                (value) => {
                    const [day, month, year] = value.split('.').map(Number);
                    const date = new Date(year, month - 1, day);
                    const minDate = new Date(1915, 0, 1);

                    if (
                        date.getFullYear() !== year ||
                        date.getMonth() !== month - 1 ||
                        date.getDate() !== day ||
                        date < minDate
                    ) {
                        return false;
                    }

                    const today = new Date();
                    const minAgeDate = new Date(
                        today.getFullYear() - 18,
                        today.getMonth(),
                        today.getDate()
                    );

                    return date <= minAgeDate;
                }
            ),
        Gender: yup.string().required('Обязательное поле'),
        Email: yup
            .string()
            .required('Обязательное поле')
            .email('Некорректный формат почты'),
        Phone: yup
            .string()
            .length(11, 'Некорректный номер телефона')
            .required('Обязательное поле'),
    });
    if (requireClientId) {
        schema = schema.shape({
            clientId: yup
                .string()
                .required('Обязательное поле')
                .length(8, 'Должно содержать ровно 8 цифр')
                .matches(/^\d+$/, 'Должно содержать только цифры'),
        });
    } else {
        schema = schema.shape({
            clientId: yup.string().nullable().notRequired(),
        });
    }

    return schema;
};